export default {
  taxes(state) {
    const { invoiceValues = {} } = state || {};
    const { taxes = [] } = invoiceValues || {};

    return taxes;
  },
  infos(state) {
    const { invoiceValues = {} } = state || {};
    const {
      order_number,
      products_value,
      origin_zipcode,
      destination_zipcode,
      total_value,
      invoice,
      cte,
    } = invoiceValues || {};

    return {
      order_number,
      products_value,
      origin_zipcode,
      destination_zipcode,
      total_value,
      invoice,
      cte,
    };
  },
  volumes(state) {
    const { invoiceValues = {} } = state || {};
    const { volumes } = invoiceValues || {};

    return volumes;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/store/getters.js